import type { TurnoverCompare } from '@/gql/graphql';
import { int, oneOf } from '@/hooks/useUrlState';

/** The comparison Select's options, in the order it lists them, with their labels. */
export const TURNOVER_COMPARE_LABELS: Record<TurnoverCompare, string> = {
  LAST_WEEK: 'Compare to previous week',
  SAME_WEEK_LAST_YEAR: 'Compare to last year',
  NONE: 'No comparison',
};

export const TURNOVER_COMPARE_OPTIONS = (Object.entries(TURNOVER_COMPARE_LABELS) as [TurnoverCompare, string][]).map(([value, label]) => ({
  value,
  label,
}));

/**
 * The turnover page's query string (see README "List pages, URL state"). `year` and `week` go together: with
 * either one absent (0 here) the page follows the latest week that has data, and picking that week again drops both.
 */
export const turnoverUrlSchema = {
  year: int({ min: 2000, max: 2100 }, 0),
  week: int({ min: 1, max: 53 }, 0),
  compare: oneOf(TURNOVER_COMPARE_LABELS, 'LAST_WEEK'),
};
